import { formatDate } from "@core/helpers"

/**
 * Relation entreprise ↔ source telle que servie par
 * `GET /api/metier/company/billing/source` (champs en snake_case).
 */
export type BillingSourceRelation = {
    createdAt: string
    dismissed: boolean
    dismissed_at?: string | null
    dismissed_by?: string | null
    /**
     * Auteur de la suppression résolu par le serveur (DEV-2251) :
     * « Prénom Nom », « Support », ou null sans auteur connu (lien sans
     * auteur enregistré ou utilisateur introuvable).
     */
    dismissed_by_name?: string | null
}

/**
 * Date (JJ/MM/AAAA, heure de Paris) et auteur de la suppression d'un lien.
 * Renvoie `null` pour un lien actif ; `date` vide si le serveur n'a pas de date,
 * `author` null si le lien n'a pas d'auteur enregistré ou si l'utilisateur
 * n'existe plus.
 */
export function getBillingRemoval(
    relation: BillingSourceRelation | undefined
): { date: string; author: string | null } | null {
    if (!relation?.dismissed) return null
    return {
        date: formatDate(relation.dismissed_at, "DD/MM/YYYY", ""),
        author: relation.dismissed_by_name || null,
    }
}
